function createClubLogic() {
  (async () => {
    const { default: ServicesClubLogic } = await import(/* webpackMode: "eager" */'www/diagnostika.mobile.blocks/b-services-mobile/b-services-card/modules/ServicesClubLogic')

    new ServicesClubLogic()
  })()
}

export default createClubLogic
